import { LanguageActionTypes } from "./constants";

export const changeLanguage = (langCode: string = "fr") => ({
  type: LanguageActionTypes.CHANGE_LANGUAGE,
  payload: langCode,
});

export const updateLanguage = (
  langCode: string,
  langName: string,
  langFlag: any
) => ({
  type: LanguageActionTypes.UPDATE_LANGUAGE,
  payload: {
    code: langCode,
    name: langName,
    flag: langFlag,
  },
});
